import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { highlights, serviceBySlug } from '../../../data/site';
import SectionIntro from '../../primitives/SectionIntro';
import Reveal from '../../primitives/Reveal';
import Figure from '../../fx/NumberTicker';
import Spotlight from '../../fx/Spotlight';

// Headline outcomes from the case studies, counted up, each linking to its full story.
// One gradient runs across all four figures (each shows its slice of a 400%-wide background).
const Results = ({ index = '02' }) => (
  <section className="section">
    <div className="container-site">
      <SectionIntro index={index} label="Results" title="Real numbers from *real implementations*">
        Real results from real clients across industries
      </SectionIntro>

      <div className="mt-[clamp(3rem,6vw,5rem)] grid border-y border-border sm:grid-cols-2 lg:grid-cols-4">
        {highlights.map((item, i) => {
          const service = serviceBySlug[item.service];
          return (
            <Reveal
              key={item.label}
              delay={i * 0.08}
              className="relative overflow-hidden border-border [&:not(:first-child)]:border-t sm:[&:nth-child(2)]:border-t-0 sm:[&:nth-child(even)]:border-l lg:border-t-0 lg:[&:not(:first-child)]:border-l"
            >
              <Spotlight size={360} />
              <Link to={`${service.path}#${item.anchor}`} data-cursor="View" className="group relative flex h-full min-h-[19rem] flex-col px-1 py-8 sm:p-8">
                <div className="flex items-center justify-between">
                  <span className="label">{service.name}</span>
                  <ArrowUpRight size={16} className="text-muted-foreground transition-transform duration-500 ease-out-expo group-hover:rotate-45 group-hover:text-foreground" aria-hidden="true" />
                </div>
                <Figure
                  value={item.value}
                  delay={0.2 + i * 0.1}
                  className="mt-auto block bg-gradient-to-r from-brand via-brand-2 to-brand bg-clip-text pt-10 text-[clamp(3.5rem,6vw,5.5rem)] font-[450] leading-none tracking-[-0.05em] text-transparent [background-size:400%_100%] [font-stretch:112%]"
                  style={{ backgroundPosition: `${(i / (highlights.length - 1)) * 100}% 0` }}
                />
                <p className="mt-4 text-[1.0625rem] leading-snug text-foreground">{item.label}</p>
                <p className="label mt-3">{item.context}</p>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Results;
